module.exports = __webpack_public_path__ + "img/unread-complaint.fd646576.svg";